<mat-card class="widget mat-elevation-z8">
    <mat-card-title>
        Feature Flags <span *ngIf="!loading">&nbsp;({{loadedDate | date:'MM/dd h:mm a'}})</span>
        <span class="grower"></span>
        <button mat-button mat-raised-button color="accent" 
            (click)="viewDetails()">View Details
        </button>
    </mat-card-title>
    <mat-card-content>
        <div id="feature-flags"></div>
    </mat-card-content>
</mat-card>